import { render, staticRenderFns } from "./plugin-group.vue?vue&type=template&id=b8f79494&scoped=true&"
import script from "./plugin-group.vue?vue&type=script&lang=js&"
export * from "./plugin-group.vue?vue&type=script&lang=js&"
import style0 from "./plugin-group.vue?vue&type=style&index=0&id=b8f79494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f79494",
  null
  
)

export default component.exports